<template>
  <div class="empty-state">
    <div v-if="icon" class="empty-icon"><nav-icon :name="icon" :size="26" /></div>
    <p class="empty-title">{{ title }}</p>
    <p v-if="hint || $slots.default" class="empty-hint"><slot>{{ hint }}</slot></p>
  </div>
</template>

<script>
import NavIcon from '../NavIcon.vue'

export default {
  name: 'EmptyState',
  components: { NavIcon },
  props: {
    title: { type: String, default: 'Nothing here yet' },
    hint: { type: String, default: '' },
    icon: { type: String, default: '' }
  }
}
</script>

<style scoped>
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 48px 24px;
  text-align: center;
  color: var(--text-secondary);
}
.empty-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px; height: 56px;
  border-radius: 50%;
  background: var(--field-bg);
  border: 1px solid var(--panel-border);
  color: var(--text-secondary);
  margin-bottom: 4px;
}
.empty-title { margin: 0; font-size: 15px; font-weight: 600; color: var(--text-primary); }
.empty-hint { margin: 0; font-size: 13px; max-width: 440px; line-height: 1.5; }
</style>
